// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KB7uUoeA_DoXjPLSEOyq {
  background-color: rgba(50, 50, 50, 0.8) !important;
  border: 1px solid #543e79 !important;
  border-radius: 10px !important;
  color: #b6b6b6 !important;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  padding: 8px 12px;
  width: 100%;
  resize: vertical;
  transition: all 0.3s;
  box-sizing: border-box;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.KB7uUoeA_DoXjPLSEOyq:hover {
  background-color: #2d2d2d !important;
  border-color: #6439ab !important;
  color: #cbcbcb !important;
  transition: all 0.3s;
}
.KB7uUoeA_DoXjPLSEOyq:focus {
  outline: none;
  border-color: #8d56e8 !important;
  background-color: #2d2d2d !important;
  color: #fff !important;
  transition: all 0.3s;
}
.KB7uUoeA_DoXjPLSEOyq:active {
  border-color: #543e79 !important;
  background-color: rgba(50, 50, 50, 0.8) !important;
  transition: all 0.3s;
}
.KB7uUoeA_DoXjPLSEOyq::placeholder {
  color: rgba(255, 255, 255, 0.5);
}
.KB7uUoeA_DoXjPLSEOyq:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  border-color: #382a50 !important;
  background-color: rgba(50, 50, 50, 0.8) !important;
  color: #636363 !important;
}
.KB7uUoeA_DoXjPLSEOyq:disabled:hover, .KB7uUoeA_DoXjPLSEOyq:disabled:focus, .KB7uUoeA_DoXjPLSEOyq:disabled:active {
  cursor: not-allowed;
  border-color: #382a50 !important;
  background-color: rgba(50, 50, 50, 0.8) !important;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/TextArea/TextArea.module.scss"],"names":[],"mappings":"AAEA;EACE,kDAAA;EACA,oCAAA;EACA,8BAAA;EACA,yBAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;AAAF;AAEE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;EACA,oBAAA;AAAJ;AAGE;EACE,aAAA;EACA,gCAAA;EACA,oCAAA;EACA,sBAAA;EACA,oBAAA;AADJ;AAIE;EACE,gCAAA;EACA,kDAAA;EACA,oBAAA;AAFJ;AAKE;EACE,+BAAA;AAHJ;AAME;EACE,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,kDAAA;EACA,yBAAA;AAJJ;AAMI;EAGE,mBAAA;EACA,gCAAA;EACA,kDAAA;AANN","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textArea": `KB7uUoeA_DoXjPLSEOyq`
};
export default ___CSS_LOADER_EXPORT___;
